var _portalIdParser$get;
import { createClient } from 'laboratory-lib';
import portalIdParser from 'PortalIdParser';
import experiments from '../../experiments.yaml';
export const laboratoryClient = createClient({
  name: 'marketplace-embed',
  // passing null causes the experiment to be skipped (for public storefront)
  identifiers: {
    portalId: (_portalIdParser$get = portalIdParser.get()) !== null && _portalIdParser$get !== void 0 ? _portalIdParser$get : null
  },
  experiments: experiments
});